import { useEffect, useState } from "react";
import GetIcon from "../../../utils/Icon";
import Tab1 from "./Tab1"; // Reuse the same Tab1 component
import ViewTable from "./Table"; // New component for view mode table
import Tabs from "../../../Components/Tabs";
import ApiResponseBox from "../../../Components/ApiResponseBox";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetPurchaseOrderByNameMutation } from "../../../store/api/purchaseorderapi";
import { usePostFinalStockAssemblyMutation, usePostStockEntryAssemblyMutation } from "../../../store/api/assemblyapi";
import Button from "../../../Core/Button/Button";
import Loader from "../../../utils/Loader";

const SEForm = () => {
  const nvg = useNavigate();
  const location = useLocation();
  const [itemList, setItemList] = useState([]);
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [tab, setTab] = useState(1);
  const [loader, setLoader] = useState(true);
  const [completeData, setCompleteData] = useState({});
  const [getPutAwayByName] = useGetPurchaseOrderByNameMutation();

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await getPutAwayByName({ 
          doctype: 'Stock Entry', 
          name: location.state 
        });
        
        if (response.error) {
          throw new Error(response.error.data?.message || "Failed to fetch putaway");
        }

        setCompleteData(response.data.message);
        setItemList(response.data.message.items || []);
        setLoader(false);
      } catch (error) {
        console.error("Error fetching putaway:", error);
        setLoader(false);
      }
    };

    if (location.state) {
      getData();
    }
  }, [location.state, getPutAwayByName]);






    const [StockEntryApi] = usePostStockEntryAssemblyMutation()
    const SubmitFunction = async () => {
      try {
       const response = await StockEntryApi({stock_entry_id:location.state});
        setptype("Message");
        setError("Stock Entry created successfully");
        setShowError(true);
        // setfinishApiResponse(response);
        setTimeout(() => {nvg("/assmbly/assembly-list")}, 2000);
    } catch (error) {
      console.log("check error msg",error)
    }
    }

  if (loader) {
    return ( <Loader /> );
  }

  return (
    <div className="d-flex flex-column" style={{flexGrow: 1}}>
      <Tabs />

      <div className="d-flex justify-content-between px-2" style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item ">Assmbly</p>
          <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
          <p className="m-0 pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px' }}>
            Stock Entry
            {/* <button className={`rounded-pill ${completeData.docstatus === 1 ? 'greenbtnforstatus' : 'newdesign2343'}`}>
              {completeData.docstatus === 1 ? "Submitted" : "Draft"}
            </button> */}
          </p>
        </div>

        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
         {/* buttons is here */}
          <Button
                    onClick={SubmitFunction}
                     style={{ backgroundColor: '#fff', height: '28px' }}
                     className="custom-btn-00989blue"
                     display={"flex"}
                   >
                   Submit
                   </Button> 
        </div>
      </div>

      <div className="d-flex flex-column" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
              <a 
                className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} 
                onClick={() => { setTab(1) }} 
                href="javascript:void(0);"
              >
                General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
              </a>
            </li>
          </ul>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px',flexGrow:'1' }}>
          <div className="col-3" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 
              po={{ 
                bom_no: completeData.bom_no,
                work_order: completeData.work_order,
                po: location.state,
                stock_entry_type: completeData.stock_entry_type 
              }} 
              grnData={completeData} 
            />
          </div>
          <div className="col-9 d-flex" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', flexDirection: 'column' }}>
            <div className="d-flex justify-content-between" style={{ gap: '5px' }}>
              <div className="d-flex" style={{ gap: '5px',marginBottom:'4px' }}>
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {itemList.length}</span></p>
                <p className="TotalQty">Ordered Quantity - <span style={{ color: '#16A34A' }}>{itemList.reduce((total, item) => total + Number(item?.qty), 0)}</span></p>
              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '99%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '3px', fontSize: '15px' }}>Item Details</p>
            </div>
            <ViewTable item_Rows={itemList} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SEForm;